import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO
} from 'app'
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import * as moment from 'moment/moment';
import { debounceTime } from 'rxjs/operators';
import { MetadataService } from '../../../BaseFramework/core/http/metadata.service';



@Component({
  selector: 'bank-details',
  templateUrl: './bank-details.component.html',
  styleUrls: ['./bank-details.component.scss']
})
export class BankDetailsComponent implements OnInit {
  _currentComponentName = 'BankDetailsComponent'
  constructor(private viewContainerRef: ViewContainerRef,
    public validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    private notification: NzNotificationService,
    private message: NzMessageService,
    private metadataService : MetadataService) { }




  //Declaraions which might need developer input
  claimsBankDetailsForm: FormGroup
  CLAIMSBANKDETAILSFORMNAME = "claimsBankDetailsForm"
  lookupsToBind = ['paymentMethodCd','AccountPurpose','paymentReasonCd', 'accountTypeCd']
  selectorOfThisComponent = 'bank-details'
  parentEvent$
  accountType = null
  /* For Document Manager */
  clientDO;
  @Output() changedField = new EventEmitter<any>()
  @Output() componentOutput = new EventEmitter<any>();
  @Input() type: string;
  @Input() state: string;
  @Input() transactionState: string;
  @Input() showComponent: boolean;
  _inputDataForEdit = null;
  @Input()
  set inputDataForEdit(value: any) {
    if (value) {
      this._inputDataForEdit = value;
      this.clientDO = value.clientDO ? value.clientDO : null; //Set clientDO
    }
  };
  @Input() emitToTransaction: boolean;
  @Input() set componentName(value) {
    if (value) this._currentComponentName = value;
  }
  payloadInEdit:any;
  payeeList = [];
  @Input() set IO(value) {
    if (value) this.payloadInEdit = value;
    
  }

  selectedBank: any = null;
  item
  fakeValidationStatus
  //TODO Pending Feature
  attemptToSubmit() { }

  searchObservable;
  public bankDataSet = []
  currentPage: any = 0;
  itemsPerPage: any = 20;

  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  EmitChangedField(data){
    this.changedField.emit(data);
  }
  getParentComponent(): Component {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
 } catch{}
  }
  getParentComponentName(): string {
    try{ return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
 } catch{}
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  _interactSubscription = null
  @Input()
  set interactSubscription(value) {
    this._interactSubscription = value || 'bankPingSubject$'
  }

  @Input() bankBeneficiaryRole: string;

  enableSpecificBankTab: number = 0;
  bankDataList = [{
    'bankFormPurpose': []
  }];

  addNewBankForm(){
    this.bankDataList.push({
      'bankFormPurpose': []
    });
    this.enableSpecificBankTab = this.bankDataList.length - 1;
  }

  filteredBankPurposeList = [];
  updateBankPurpose(event,index) {
    let selectedPurpose = []
    let completeBankPurposeList = this.commonUtilty.deepCopy(this.bankPurposeCd); // get complete lookup in a variable to splice and assign the unselected value.
    if (this.bankDataList && Array.isArray(this.bankDataList)) {
      this.bankDataList.forEach(bank => {
        selectedPurpose.push(...bank.bankFormPurpose)
      })
    }
    selectedPurpose.forEach(element => {
      const index = completeBankPurposeList.findIndex((obj) => obj.lookupKey === element);
      // If the object is found, remove it from the array and update the variable
      if (index > -1)
        completeBankPurposeList.splice(index, 1);
    })
    this.filteredBankPurposeList[index] = completeBankPurposeList;
    // Log the updated array
    console.log("filter list of purpose after selection: ", this.filteredBankPurposeList);
    console.log("bank Data List check: ", this.bankDataList)
  }

  bankPurposeCd = [
    {
        "lookupKey": "autoDebt",
        "lookupValue": "Auto Debt",
        "sortOrder": 1,
        "criteriaLookupKey": null,
        "displayFl": null,
        "workflowStatusCd": "PUBLISH",
        "lookupAddValue1": null,
        "lookupAddValue2": null,
        "defaultFl": null
    },
    {
        "lookupKey": "refundPremium",
        "lookupValue": "Refund Premium",
        "sortOrder": 3,
        "criteriaLookupKey": null,
        "displayFl": null,
        "workflowStatusCd": "PUBLISH",
        "lookupAddValue1": null,
        "lookupAddValue2": null,
        "defaultFl": null
    },
    {
        "lookupKey": "claimPayment",
        "lookupValue": "Claim Payment",
        "sortOrder": 2,
        "criteriaLookupKey": null,
        "displayFl": null,
        "workflowStatusCd": "PUBLISH",
        "lookupAddValue1": null,
        "lookupAddValue2": null,
        "defaultFl": null
    }
  ]

  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe()
    let pingSubject$ = this.emitToTransaction ? this.interactService.pingSubject$ : this.interactService.bankPingSubject$;
    this.parentEvent$ = pingSubject$.subscribe((param: any) => {
      if(!this.showComponent){
        let validationResult = {isInvalid: false, errorDOs: []};
        this.EmitComponentOutput(validationResult)
        return;
      }
      let validationResult = this.validationUtilService.validateOutput(this.claimsBankDetailsForm,this.CLAIMSBANKDETAILSFORMNAME,this.getCurrentComponentName())
      this.claimsBankDetailsForm.controls['paymentReasonCd'].setValue(
        this.commonUtilty.convertArrayToCSV(this.bankDataList[0]['bankFormPurpose'])
      );
      if (!validationResult.isInvalid)
        this.EmitComponentOutput(this.claimsBankDetailsForm.value)
      else {
          this.EmitComponentOutput(validationResult)
      }
    })
  }


  //Initializations
  lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)

  ngOnInit() {
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px'
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.selectorOfThisComponent}></${this.selectorOfThisComponent}>, has been used. `, consoleStyle)
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle)
      console.log(`%cExample , <${this.selectorOfThisComponent} (componentOutput)='doSomethingOnDataReceived()'></${this.selectorOfThisComponent}>`, consoleStyle)
      console.groupEnd();
    }
    this.initializeBankDetailForm(this._inputDataForEdit)
    this.subscribeToParentEvent()

    /* OCR */
    this.setOCRchangeDetection();
    this.fetchUserCountry();
    this.setPayeelist(this._inputDataForEdit)
    this.getLookups();
  }


  baseCompanyCountryCd = null;
  fetchUserCountry(){
    this.metadataService.fetchUserCountry().subscribe(data =>{
        this.baseCompanyCountryCd = data && data.companyMasterDO && data.companyMasterDO.applicableCountryCd ? 
                                    data.companyMasterDO.applicableCountryCd : 'INDIA';
    });
  }

  /**
   * Form Trasactions
   */

  //TODO Ramesh, Map the for with PaymentDO

  initializeBankDetailForm(data?) {
    let payload = data || {}
    this.claimsBankDetailsForm = this.fb.group({
      paymentReasonCd: payload['paymentReasonCd'],
      bankName: payload['bankName'],
      address: payload['address'],
      cityCd: payload['cityCd'],
      bankBranchName: payload['bankBranchName'],
      ifscCd: null,
      clientRefGuid: payload['clientRefGuid'],
      FPSPaymentMethod: payload['FPSPaymentMethod'],
      email:payload['email'],
      FPSIdentifier: payload['FPSIdentifier'],
      countryCode: payload['countryCode'],
      mobile: payload['mobile'],
      bankNumber: payload['bankNumber'],
      branchNumber: payload['branchNumber'],
      accountCurrency: payload['accountCurrency'],
      bankNameAndBranch: payload['bankNameAndBranch'],
      country: payload['country'],
      postalCode:payload['postalCode'],
      sortCode: null,
      bankCode: null,
      branchCode: null,
      swiftCode: null,
      IBAN:null,
      addrLine1: null,
      town:null,
      postCode: null,
      accountTypeCd:  this.validationUtilService.setValidationsForFormControl('accountTypeCd', this.CLAIMSBANKDETAILSFORMNAME,payload['accountTypeCd']),
      purposeCd:  this.validationUtilService.setValidationsForFormControl('purposeCd', this.CLAIMSBANKDETAILSFORMNAME,payload['purposeCd']),
      accountNum: this.validationUtilService.setValidationsForFormControl('accountNum', this.CLAIMSBANKDETAILSFORMNAME, payload['accountNum']),
      accountHolderName: this.validationUtilService.setValidationsForFormControl('accountHolderName', this.CLAIMSBANKDETAILSFORMNAME, payload['accountHolderName']),
      paymentMethodCd: this.validationUtilService.setValidationsForFormControl('paymentMethodCd', this.CLAIMSBANKDETAILSFORMNAME, payload['paymentMethodCd']),
      branchIdNum1: this.validationUtilService.setValidationsForFormControl('branchIdNum2', this.CLAIMSBANKDETAILSFORMNAME, payload['branchIdNum1']),
      branchIdNum2: this.validationUtilService.setValidationsForFormControl('branchIdNum2', this.CLAIMSBANKDETAILSFORMNAME, payload['branchIdNum2']),
      retypeaccountNum: this.validationUtilService.setValidationsForFormControl('retypeaccountNum', this.CLAIMSBANKDETAILSFORMNAME, payload['accountNum']),
      retypeAccountHolderName: this.validationUtilService.setValidationsForFormControl('retypeAccountHolderName', this.CLAIMSBANKDETAILSFORMNAME, payload['accountHolderName']),
      /*bankName: this.validationUtilService.setValidationsForFormControl('bankName', this.CLAIMSBANKDETAILSFORMNAME, payload['bankName']),
      address: this.validationUtilService.setValidationsForFormControl('address', this.CLAIMSBANKDETAILSFORMNAME, payload['address']),
      cityCd: this.validationUtilService.setValidationsForFormControl('cityCd', this.CLAIMSBANKDETAILSFORMNAME, payload['cityCd']),
      bankBranchName: this.validationUtilService.setValidationsForFormControl('bankBranchName', this.CLAIMSBANKDETAILSFORMNAME, payload['bankBranchName']),
      retypeaccountNum: this.validationUtilService.setValidationsForFormControl('retypeaccountNum', this.CLAIMSBANKDETAILSFORMNAME, payload['accountNum']),
      retypeAccountHolderName: this.validationUtilService.setValidationsForFormControl('retypeAccountHolderName', this.CLAIMSBANKDETAILSFORMNAME, payload['accountHolderName']),
      ifscCd: this.validationUtilService.setValidationsForFormControl('ifscCd', this.CLAIMSBANKDETAILSFORMNAME),
      clientRefGuid: this.validationUtilService.setValidationsForFormControl('clientRefGuid', this.CLAIMSBANKDETAILSFORMNAME, payload['clientRefGuid']),
      FPSPaymentMethod: this.validationUtilService.setValidationsForFormControl('FPSPaymentMethod', this.CLAIMSBANKDETAILSFORMNAME, payload['FPSPaymentMethod']),
      email: this.validationUtilService.setValidationsForFormControl('email', this.CLAIMSBANKDETAILSFORMNAME, payload['email']),
      FPSIdentifier: this.validationUtilService.setValidationsForFormControl('FPSIdentifier', this.CLAIMSBANKDETAILSFORMNAME, payload['FPSIdentifier']),
      countryCode: this.validationUtilService.setValidationsForFormControl('countryCode', this.CLAIMSBANKDETAILSFORMNAME, payload['countryCode']),
      mobile: this.validationUtilService.setValidationsForFormControl('mobile', this.CLAIMSBANKDETAILSFORMNAME, payload['mobile']),
      bankNumber: this.validationUtilService.setValidationsForFormControl('bankNumber', this.CLAIMSBANKDETAILSFORMNAME, payload['bankNumber']),
      branchNumber: this.validationUtilService.setValidationsForFormControl('branchNumber', this.CLAIMSBANKDETAILSFORMNAME, payload['branchNumber']),
      accountCurrency: this.validationUtilService.setValidationsForFormControl('accountCurrency', this.CLAIMSBANKDETAILSFORMNAME, payload['accountCurrency']),
      bankNameAndBranch: this.validationUtilService.setValidationsForFormControl('bankNameAndBranch', this.CLAIMSBANKDETAILSFORMNAME, payload['bankNameAndBranch']),
      country: this.validationUtilService.setValidationsForFormControl('country', this.CLAIMSBANKDETAILSFORMNAME, payload['country']),
      postalCode: this.validationUtilService.setValidationsForFormControl('postalCode', this.CLAIMSBANKDETAILSFORMNAME, payload['postalCode']),
      sortCode: this.validationUtilService.setValidationsForFormControl('sortCode', this.CLAIMSBANKDETAILSFORMNAME),
      bankCode: this.validationUtilService.setValidationsForFormControl('bankCode', this.CLAIMSBANKDETAILSFORMNAME),
      branchCode: this.validationUtilService.setValidationsForFormControl('branchCode', this.CLAIMSBANKDETAILSFORMNAME),
      swiftCode: this.validationUtilService.setValidationsForFormControl('swiftCode', this.CLAIMSBANKDETAILSFORMNAME),
      IBAN: this.validationUtilService.setValidationsForFormControl('IBAN', this.CLAIMSBANKDETAILSFORMNAME),
      addrLine1: this.validationUtilService.setValidationsForFormControl('addrLine1', this.CLAIMSBANKDETAILSFORMNAME),
      town: this.validationUtilService.setValidationsForFormControl('town', this.CLAIMSBANKDETAILSFORMNAME),
      postCode: this.validationUtilService.setValidationsForFormControl('postCode', this.CLAIMSBANKDETAILSFORMNAME),
      accountType: this.validationUtilService.setValidationsForFormControl('postCode', this.CLAIMSBANKDETAILSFORMNAME),*/
    });
    let AccountPurpose = payload['paymentReasonCd']
    this.bankDataList[0]['bankFormPurpose'] = this.commonUtilty.convertCSVToArray(AccountPurpose)
  }
  

  @Input() intimationForm: FormGroup;

  /* Bank Details */
  bank: any = {};

  fetchFromIFSC() {


    let ifscCd = this.claimsBankDetailsForm.get('branchIdNum1').value;
    if (ifscCd) {
      let serviceId = this.message.loading('Searching').messageId;
      let url = 'fetchBankByIfscCd';
      this.searchObservable = this.apiRequestService.getCallWithAPIMapper(url,null,null,[ifscCd]).subscribe(data => {
        if (this.commonUtilty.isArrayIterable(data)) {
          this.selectedBank = data[0];
          this.claimsBankDetailsForm.controls['bankName'].setValue(data[0]['bankName']);
          this.claimsBankDetailsForm.controls['bankBranchName'].setValue(data[0]['bankBranchName']);
          this.claimsBankDetailsForm.controls['branchIdNum2'].setValue(data[0]['branchIdNum2']);
          this.claimsBankDetailsForm.controls['branchIdNum1'].setValue(data[0]['branchIdNum1']);

          if(this._inputDataForEdit){
            this._inputDataForEdit.bankName = data[0]['bankName']
          this._inputDataForEdit.branchIdNum1 = data[0]['branchIdNum1']
          this._inputDataForEdit.branchIdNum2 = data[0]['branchIdNum2']
          this._inputDataForEdit.bankBranchName = data[0]['bankBranchName']
        }

          // test data

          this._inputDataForEdit.accountNum = this.claimsBankDetailsForm.get('accountNum').value;
          this._inputDataForEdit.retypeaccountNum = this.claimsBankDetailsForm.get('accountNum').value;
          this._inputDataForEdit.accountHolderName = this.claimsBankDetailsForm.get('accountHolderName').value;
          this._inputDataForEdit.retypeAccountHolderName = this.claimsBankDetailsForm.get('accountHolderName').value;
          this._inputDataForEdit.accountTypeCd = this.claimsBankDetailsForm.get('accountTypeCd').value;
          this._inputDataForEdit.paymentMethodCd = this.claimsBankDetailsForm.get('paymentMethodCd').value;
          this._inputDataForEdit.purposeCd = this.claimsBankDetailsForm.get('purposeCd').value;
          // this._inputDataForEdit.transactionNumber = this.claimsBankDetailsForm.get('transactionNumber').value;
          this._inputDataForEdit.paymentReasonCd = this.commonUtilty.convertArrayToCSV(this.bankDataList[0]['bankFormPurpose']);
          




          this.initializeBankDetailForm(this._inputDataForEdit);
          if (!!!this.selectedBank)
            this.notification.error('No data found', 'Data not found');
          //this.initializeBankDetailForm(this.selectedBank);
          this.message.remove(serviceId);
        } else {
          // this.notification.error('No data found', 'Data not found for the IFSC Code');
          // this.initializeBankDetailForm(this.selectedBank);
          this.message.remove(serviceId);
        }
      });
    }
    else
      this.message.error('Please enter IFSC code', { nzDuration: 1000 });

  }


  

  FormFieldNameMap = {

    accountNum: "Bank Account No",
    accountHolderName: "Account Holder Name",
    paymentMethodCd: "Method of Payout",
    // transactionNumber: "Transaction Number",
    branchIdNum1: "IFSC",
    branchIdNum2: "MICR",
    bankName: "Name of Bank",
    address: "Address",
    cityCd: "City",
    bankBranchName: "Branch",
    accountTypeCd: "Account Type",
    purposeCd: "Purpose"


  }






  /* Bank CHEQUE Upload */
  showUploadList = {
    showPreviewIcon: true,
    showRemoveIcon: true,
    hidePreviewIconInNonImage: true
  };
  fileList = [{
    uid: 1,
    name: 'xxx.png',
    status: 'done',
    url: "https://bse2nse.com/images/cancelled_cheque.png"
  }];
  previewImage: string | undefined = '';
  previewVisible = false;
  handlePreview = (file: NzUploadFile) => {
    this.previewImage = file.url || file.thumbUrl;
    this.previewVisible = true;
  };




  searchBanks() {
    var formObject = {
      ifscCd: this.claimsBankDetailsForm.get('ifscCd').value,
      cityCd: this.claimsBankDetailsForm.get('cityCd').value,
      bankBranchName: this.claimsBankDetailsForm.get('bankBranchName').value,
      bankName: this.claimsBankDetailsForm.get('bankName').value
    }

    var payload = this.convertToSearchRequestPayload(formObject)

    if (this.searchObservable != null)
      this.searchObservable.unsubscribe();
    this.searchObservable = this.apiRequestService.post("bank/search", payload).subscribe(data => {
      this.bankDataSet = data;
      console.log("bankDataSet", this.bankDataSet);

    });

  }



  convertToSearchRequestPayload(formObject) {
    console.log(formObject)
    var payload = {}
    payload["page"] = this.currentPage
    payload["size"] = this.itemsPerPage || 10
    payload["searchCriteriaList"] = []

    var attributes = JSON.parse(JSON.stringify(Object.keys(formObject)));

    attributes.forEach(key => {
      var criteriaItem = {}
      criteriaItem["paramName"] = key
      criteriaItem["paramValue"] = formObject[key];
      payload["searchCriteriaList"].push(criteriaItem)
    });

    return payload
  }

  fetchBankDetails() {
    this.initializeBankDetailForm(this.selectedBank);
  }

  handleChange(event, data) {
    this.selectedBank = data;
  }


  modSearchBank: boolean = false;

  @Input() entityGuid: string = '';

  /* =================== OCR =================== */
  OCRverificationData: Array<any> = [];
  /* If any of the inputs that affect OCR component has changed, we need to reset it */
  setDataToBeVerifiedByOCR() {
    this.OCRverificationData = [
      /* key: user-friendly name for item; value: the value to be OCR'd; status: current status of verification */
      { key: 'Bank Account Number', value: this.claimsBankDetailsForm.get('accountNum').value || 'N.A', status: 'Pending' },
      { key: 'Account Holder Name', value: this.claimsBankDetailsForm.get('accountHolderName').value || 'N.A', status: 'Pending' }
    ]
  }
  /* Subscriptions for CHANGES: Any changes made to the form here must be reflected */
  setOCRchangeDetection() {
    /* Subscriptions for OCR verification */
    this.claimsBankDetailsForm.get('accountNum').valueChanges
      .pipe(debounceTime(1000)).subscribe(val => {
        this.setDataToBeVerifiedByOCR();
      });
    this.claimsBankDetailsForm.get('accountHolderName').valueChanges
      .pipe(debounceTime(1000)).subscribe(val => {
        this.setDataToBeVerifiedByOCR();
      });
  }
  /* =================== / OCR =================== */


  accNoCheck: any = true
  onAccNoChange(event, type, guid?) {

    let AccNo = this.claimsBankDetailsForm.get('accountNum').value
    let reAccNo = this.claimsBankDetailsForm.get('retypeaccountNum').value
    let accNoCheckOutput = null
    if (type == "EVENT") {
      if (AccNo !== reAccNo)
        accNoCheckOutput = false
      else
        accNoCheckOutput = true
    } else {
      if (AccNo !== reAccNo)
        accNoCheckOutput = false
      else
        accNoCheckOutput = true
    }
    this.accNoCheck = accNoCheckOutput;
  }


  accNameCheck: any = true
  onNameChange(event, type) {


    let AccName = this.claimsBankDetailsForm.get('accountHolderName').value
    let reAccName = this.claimsBankDetailsForm.get('retypeAccountHolderName').value
    let accNoCheckOutput = null
    if (type == "EVENT") {
      if (AccName !== reAccName)
        accNoCheckOutput = false
      else
        accNoCheckOutput = true
    } else {
      if (AccName !== reAccName)
        accNoCheckOutput = false
      else
        accNoCheckOutput = true
    }
    this.accNameCheck = accNoCheckOutput;
  }

  setPayeelist(response){
    let payee = []
    if (this.transactionState === 'policyDataEntryTask'){
      payee = this.commonUtilty.searchAndStitchClientDOForPayer(response, this.payloadInEdit)
      if(payee){
        this.payeeList.push(payee)
      }
    }
    else{
      payee = this.commonUtilty.searchAndStitchClientDO(response, this.payloadInEdit)
      if(payee){
        this.payeeList.push(payee);
      }
    }
    console.log("payee list", JSON.stringify(this.payeeList));
    // this.subscribeToAllBankChildren(this.payeeList);
    console.log("list of payee getting added at line No.78: ",this.payeeList)
  }
  formDataChangeHandler(fieldKey){
    // let me = this;
    // me.interactService.formFieldChangeSubject(fieldKey);
    this.changedField.emit(fieldKey);
  }

  accountTypeLookup : any = [];
  paymentMethodLookup : any = [];
  accountPurposeLookup : any = [];

  getLookups() {
    this.lookupDataService.getLookup('accountTypeCd').subscribe(resp => {
      this.accountTypeLookup = resp;
    })
    this.lookupDataService.getLookup('paymentMethodCd').subscribe(resp => {
      this.paymentMethodLookup = resp;
    })
    this.lookupDataService.getLookup('AccountPurpose').subscribe(resp => {
      this.accountPurposeLookup = resp;
    })
  }
}
